export enum ParameterizationStepTypeEnum {
  GRUPO = "GRUPO",
  ELIMINATORIA_SIMPLES = "ELIMINATORIA_SIMPLES",
  ELIMINATORIA_DUPLA = "ELIMINATORIA_DUPLA",
  ROUND_ROBIN = "ROUND_ROBIN"
}
  